import * as types from './actionTypes';
import api from '../../../api/';

export function getData() {
  // body...
  return async (dispatch, getState) => {
    dispatch({
      type: types.LOADING,
    });
    try {
      const followers = await api.getFollowers();
      dispatch({
        type: types.LOADED,
        followers,
      });
    } catch (error) {
      console.log(error);
    }
  };
}
